import React from 'react';

export const DeleteQuickLink = ({ quickLink }) => (
    <>
            <strong>Text</strong>
            <br />
            <span>{quickLink.text}</span>
            <br />
            <br />
            <strong>URL</strong>
            <br />
            <span>{quickLink.url}</span>
    </>
);